import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";

export function passwordValidator(): ValidatorFn {
  const regex = /^(?=.*[A-Za-z])(?=.*\d).{8,}$/;

  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;

    if (!value) return null;

    return regex.test(value) ? null : { passwordInvalid: true };
  };
}
